import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { get_all_test_requirements } from "../../endpoints/API";
// import { useSelector } from "react-redux";

export const fetchTestRequirement = async (
  setTestRequirements,
  baseUrl,
  prodTestUrl
) => {
  try {
    const response = await get_all_test_requirements();
    if (response.statusText=="OK") {
      const data = response?.data;
      setTestRequirements(data);
    } else {
      message.error("Failed to fetch test requirements.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching test requirements.");
  }
};
